export default function BtnNextSection($DOM, classes) {
	const $container = $('.btn-next-section');

	if(!$container.length) {
		return false;
	}

	$container.click(function(event) {
		event.preventDefault();

		const $this         = $(this);
		const _offset       = $this.parents('section').next().offset().top;
		const _headerHeight = $('.header').innerHeight();

		$DOM.htmlTag.delay(100).animate({
			scrollTop: _offset - _headerHeight
		}, 1000);
	});
}